import React from "react"
import { Grid, Row, Col, Image } from "react-bootstrap"
import { Link } from "react-router-dom"

import Sidebar from "../components/Sidebar.js"
import logo from "../assets/gicaomo-bruno-logo.svg"

const Header = () => (
  <header>
    <Grid fluid>
      <Row>
        <Col xs = { 6 }>
          <div className = { "logo" }>
            <Link to = { "/" }>
              <Image src = { logo } alt={ "Giacomo Bruno Photographer" } />
            </Link>
          </div>
        </Col>
        <Col xs = { 6 }>
          <Sidebar />
          <div className = { "get-in-touch" }>
            <Link
              to = { "/contacts" }
              className = { "get-in-touch" }
            >
              <span>Get in touch</span>
            </Link>
          </div>
        </Col>
      </Row>
    </Grid>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js